import moment from 'moment';
import chunkSlots from './chunkSlots';
import { dateInZone, wallClockToInstant } from './zonedTime';

function getChunkedSlots(startDateTime, endDateTime, userSettings) {
  const slots = [];

  if (!startDateTime || !endDateTime || !userSettings) {
    return slots;
  }

  const { AvailableWeekDays, StartingFreeTime, EndingFreeTime } = userSettings;

  if (!AvailableWeekDays || !Array.isArray(AvailableWeekDays) || AvailableWeekDays.length === 0) {
    return slots;
  }

  const zoned = userSettings.TimeZone && userSettings.LocalStartingFreeTime && userSettings.LocalEndingFreeTime;
  if (!zoned && (!StartingFreeTime || !EndingFreeTime)) {
    return slots;
  }

  if (!startDateTime.isValid() || !endDateTime.isValid() || startDateTime >= endDateTime) {
    return slots;
  }

  if (zoned) {
    let firstDate;
    let lastDate;
    try {
      firstDate = dateInZone(userSettings.TimeZone, startDateTime.valueOf());
      lastDate = dateInZone(userSettings.TimeZone, endDateTime.valueOf() - 1);
    } catch (error) {
      if (error instanceof RangeError) return slots;
      throw error;
    }
    let zonedSlots = slots;
    for (let date = moment.utc(firstDate).subtract(1, 'day'); date.format('YYYY-MM-DD') <= lastDate; date = date.clone().add(1, 'day')) {
      const recruiterDate = date.format('YYYY-MM-DD');
      if (AvailableWeekDays.includes(date.format('dddd'))) {
        const endDate = userSettings.LocalEndingFreeTime < userSettings.LocalStartingFreeTime
          ? date.clone().add(1, 'day').format('YYYY-MM-DD') : recruiterDate;
        const start = wallClockToInstant(recruiterDate, userSettings.LocalStartingFreeTime, userSettings.TimeZone);
        const end = wallClockToInstant(endDate, userSettings.LocalEndingFreeTime, userSettings.TimeZone);
        if (start && end) {
          const clippedStart = moment.max(startDateTime, start.local());
          const clippedEnd = moment.min(endDateTime, end.local());
          if (clippedStart < clippedEnd) zonedSlots = [...zonedSlots, ...chunkSlots(clippedStart, clippedEnd, userSettings.SlotDuration, moment())];
        }
      }
    }
    return zonedSlots;
  }

  const settingsStartUTC = moment.utc(StartingFreeTime, 'HH:mm:ss');
  const settingsEndUTC = moment.utc(EndingFreeTime, 'HH:mm:ss');
  const settingsStartLocal = settingsStartUTC.local();
  const settingsEndLocal = settingsEndUTC.local();
  const allowedStart = startDateTime.clone().set({
    hour: settingsStartLocal.hour(), minute: settingsStartLocal.minute(),
    second: settingsStartLocal.second(), millisecond: 0,
  });
  const allowedEnd = startDateTime.clone().set({
    hour: settingsEndLocal.hour(), minute: settingsEndLocal.minute(),
    second: settingsEndLocal.second(), millisecond: 0,
  });
  const dayName = startDateTime.format('dddd');

  // Stored as a UTC wall clock, so east or west enough the local end lands before the
  // local start: a window running past midnight, not a day to leave inverted and empty.

  // STRICTLY before - equal boundaries are an empty window, not a 24h one, and an
  // unconfigured .NET calendar sends '00:00:00' for both. Matches the slot engine.
  if (allowedEnd.isBefore(allowedStart)) {
    allowedEnd.add(1, 'day');
  }

  const effectiveStart = moment.max(startDateTime, allowedStart);
  const effectiveEnd = moment.min(endDateTime, allowedEnd);

  if (effectiveStart >= effectiveEnd) {
    return slots;
  }

  if (!AvailableWeekDays.includes(dayName)) {
    return slots;
  }

  return chunkSlots(effectiveStart, effectiveEnd, userSettings.SlotDuration, moment());
}

export default getChunkedSlots;
